<template>
  <div class="sign-in-modal">
    <ModalContainer>
      <div class="sign-in-modal__title">Sign in to your account</div>
      <UserLoginForm key="login" v-if="!isMFAFormShown" />
      <TwoFactorForm key="two-factor" v-else />
    </ModalContainer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import UserLoginForm from '@/components/login/UserLoginForm.vue'
import TwoFactorForm from '@/components/login/two-factor/TwoFactorForm.vue'
import ModalContainer from '@/components/shared/ModalContainer.vue'

export default {
  name: 'SignInModal',
  components: {
    ModalContainer,
    UserLoginForm,
    TwoFactorForm,
  },
  computed: {
    ...mapState({
      isMFAFormShown: state => state.app.isMFAFormShown,
      isLoadingCaptcha: state => state.app.isLoadingCaptcha,
    }),
  },
}
</script>

<style lang="scss">
.sign-in-modal {
  @include font-book;
  &__title {
    font-weight: 450;
    font-size: rem(24px);
    line-height: 32px;
    text-align: center;
    margin: 10px 0 30px 0;
    color: var(--white);
  }
}
</style>
